<div [id]="uniqueId" class="phone-input-root" aria-label="Phone number input">
    <div class="phone-input-container">
        <button type="button" class="phone-input-prefix" [class.prefix-open]="dropdownOpen" aria-haspopup="listbox"
            [attr.aria-expanded]="dropdownOpen" (click)="toggleDropdown()">
            <img class="flag-icon" [src]="selectedPrefix?.url ?? '/assets/images/flags/spain.webp'"
                alt="{{ selectedPrefix?.code ?? 'flag' }}" loading="lazy" />
            <p>{{selectedPrefix?.prefix}}</p>
            <img class="arrow-icon" src="../../../assets/icons/arrow-down.svg" alt="Flag" class="flag" />
        </button>

        <input class="number-input" type="tel" [formControl]="localNumber" placeholder="000 000 000"
            [attr.maxlength]="getMaxLocalLengthForSelectedPrefix()"
            [attr.placeholder]="formatLocalForDisplay(localNumber.value || '') || '000 000 000'"
            (focus)="dropdownOpen = false;" (wheel)="$event.preventDefault()"
            [attr.aria-invalid]="localNumber.invalid ? 'true' : 'false'"
            [attr.aria-describedby]="uniqueId + '-error'" />

    </div>

    <div class="error-message" *ngIf="validationMessage" [id]="uniqueId + '-error'">
        {{ validationMessage }}
    </div>

    <div class="dropdown" *ngIf="dropdownOpen">
        <div [ngClass]="(selectedPrefix && selectedPrefix.code === p.code) ? 'selected-dropdown-item': 'dropdown-item'"
            [style.borderBottom]="'1px solid var(--Neutrals-Middle-Grey)'"
            *ngFor="let p of FavoritePrefixes; trackBy: trackByCode" (click)="onPrefixChange(p)">

            <div class="dropdown-item-content">
                <img class="flag-icon" [src]="p?.url" alt="" loading="lazy" />
                <p>{{ p.nameTranslated }}</p>
                <p>{{ p.prefix }}</p>
            </div>

            <img *ngIf="(selectedPrefix && selectedPrefix.code === p.code)" class="check-icon"
                src="../../../../../../../../assets/icons/solid_check.webp" alt="Check Icon" loading="lazy">

        </div>

        <div class="dropdown-item-spliter">
            {{'ALL_COUNTRIES' | translate}}
        </div>
        <div class="dropdown-scroll-container">
            <div [ngClass]="(selectedPrefix && selectedPrefix.code === p.code) ? 'selected-dropdown-item': 'dropdown-item'"
                [style.borderBottom]="!last ? '1px solid var(--Neutrals-Middle-Grey)' : ''"
                *ngFor="let p of prefixes; let last = last trackBy: trackByCode" (click)="onPrefixChange(p)">

                <div class="dropdown-item-content">
                    <img class="flag-icon" [src]="p?.url" alt="" loading="lazy" />
                    <p>{{ p.nameTranslated }}</p>
                    <p>{{ p.prefix }}</p>
                </div>

                <img *ngIf="(selectedPrefix && selectedPrefix.code === p.code)" class="check-icon"
                    src="../../../../../../../../assets/icons/solid_check.webp" alt="Check Icon" loading="lazy">

            </div>
        </div>

    </div>
</div>